/** Service Desk console: the Field service tab and the deflection insight cards of Service reports (SD-S3-14, SD-S4-09). The "i" definitions come from the API. */
export const serviceReportsField = {
  tabs: { field: "Field service" },
  field: {
    none: "Not set",
    noEngineer: "Not assigned",
    noOrganisation: "No organisation",
    noModel: "No model recorded",
    engineer: "Engineer",
    organisation: "Organisation",
    member: "Team member",
    model: "Asset model",
    note: "Figures come from visits and time entries; they hold counts and hours, never notes or client details.",
    followUp: { label: "Follow-up window", hint: "A repeat visit within this window means the first one did not fix it.", option: "{{days}} days" },
    kpi: {
      visits: "Visits completed",
      visitsSub: "of {{total}} planned in the period",
      firstTimeFix: "First-time fix",
      fixSub: "{{fixed}} of {{completed}} corrective visits",
      onSite: "On-site response",
      onSiteSub: "{{met}} of {{ended}} targets met",
      utilisation: "Engineer utilisation",
      utilisationSub: "{{booked}} h booked of {{available}} h available",
    },
    visits: { title: "Visits by engineer", sub: "Planned in {{period}}", total: "Visits", completed: "Completed", rate: "Completion rate" },
    fix: { title: "First-time fix by engineer", sub: "Repeat visit within {{days}} days counts against it", rate: "First-time fix", completed: "Completed", repeat: "Repeat visits" },
    onSite: { title: "On-site response by organisation", sub: "Targets that ended in {{period}}", compliance: "Compliance", met: "Met", breached: "Breached" },
    utilisation: { title: "Utilisation by engineer", sub: "Booked on-site time over working hours, {{period}}", rate: "Utilisation", booked: "Booked", available: "Available" },
    time: { title: "Time recorded by team member", sub: "{{hours}} h recorded in the period", hours: "Hours", billable: "Billable hours", entries: "Entries" },
    reliability: { title: "Asset reliability by model", sub: "Incidents per 100 units, {{period}}", per100: "Per 100 units", tickets: "Incidents", units: "Units", mtbf: "Mean time between failures" },
  },
  insight: {
    label: "AI suggestions and deflection",
    channel: "Channel",
    topic: "Topic",
    kpi: {
      accept: "Triage suggestions accepted",
      acceptSub: "{{accepted}} of {{suggested}} suggestions",
      high: "Accepted at high confidence",
      highSub: "{{count}} suggestions at 80% or more",
      completion: "Intake completion",
      completionSub: "{{tickets}} tickets from {{started}} conversations",
      dropped: "Left at the ticket form",
      droppedSub: "{{form}} reached the form",
    },
    triage: { title: "Triage suggestions by field", sub: "Asked for in {{period}}; accepted when the ticket holds the value now", suggestion: "Suggestion", rate: "Accept rate", suggested: "Suggested", accepted: "Accepted" },
    funnel: { title: "Intake funnel by channel", sub: "Concern conversations started in {{period}}", started: "Started", form: "Reached the form", tickets: "Tickets", rate: "Completion" },
    deflection: { sub: "Concern conversations started in {{period}}", rate: "Deflection rate", started: "Started", deflected: "Deflected" },
  },
} as const;
